/**
 * Adds cssClass "v3sDesktop"
 * @class directive_v3sDesktop
 * @memberOf v3sWbtPlayerApp:page:generalDirectives
 */
angular.module('v3sWbtPlayerApp').directive('v3sDesktop', ["v3sContentConfig", "$timeout", function (v3sContentConfig, $timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var onDesktop = attrs.v3sDesktop == "true";
            var onMobile = attrs.v3sMobile == "true";

            if (onDesktop && !onMobile) {
                element.addClass("only-desktop");

            } else if (!onDesktop && onMobile) {
                if(v3sContentConfig.responsive){
                    element.addClass("only-mobile");
                } else {
                    element.addClass("v3s-hide");
                }
            } else if (!onDesktop && !onMobile) {
                element.addClass("v3s-hide");
            }
        }
    }
}]);